module.exports = __webpack_public_path__ + "static/media/steam.4d722827.png";